import { S } from './TileTitleWithPrice';
import { useStaticContext } from '../../../../utilities/context/static/StaticContext';

type TileTitlePriceProps = {
  discountedPrice?: string | null;
  initialPrice: string | undefined;
  originalPriceCopy: string | undefined;
  discountedColor?: string;
};

export const TileTitlePrice = ({
  discountedPrice,
  initialPrice,
  originalPriceCopy,
  discountedColor,
}: TileTitlePriceProps) => {
  const {
    configuration: { lowestPriceDisplay, showLowestPriceText },
  } = useStaticContext();

  const isOnlyLowestPrice = lowestPriceDisplay === 'ONLY_LOWEST_PRICE' && showLowestPriceText;
  const hasDiscount = Boolean(discountedPrice && discountedPrice !== initialPrice);
  const shouldShowOriginalPrice = !isOnlyLowestPrice && hasDiscount && initialPrice;

  return (
    <S.PriceWrapper>
      {shouldShowOriginalPrice && (
        <S.PriceLowest30Days data-testid="product-tile-initial-price">
          {originalPriceCopy} {initialPrice}
        </S.PriceLowest30Days>
      )}
      {hasDiscount ? (
        <S.DiscountedPrice $color={discountedColor} data-testid="product-tile-price">
          {discountedPrice}
        </S.DiscountedPrice>
      ) : (
        <S.InitialPrice data-testid="product-tile-price">{initialPrice}</S.InitialPrice>
      )}
    </S.PriceWrapper>
  );
};
